import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { BreadcrumbJsonLd, ItemListJsonLd } from "../components/JsonLd";
import { Film, Sparkles } from "lucide-react";

export default function Channels() {
  const [channels, setChannels] = useState([]);
  useEffect(() => { api.get("/channels").then(r => setChannels(r.data)); }, []);
  const hasShortsChannels = channels.some(c => c.shorts_only);
  return (
    <div className="max-w-[1400px] mx-auto px-6 py-10">
      <BreadcrumbJsonLd items={[{ name: "Accueil", path: "/" }, { name: "Chaînes", path: "/channels" }]} />
      <ItemListJsonLd
        name="Chaînes Fedevo 2.0 · Média urbain spécialisé streaming"
        description="Catalogue des chaînes urbaines : hip-hop, street culture, breakdance, DJ sessions, beatbox, graffiti"
        items={channels.map(c => ({
          name: c.name,
          path: c.shorts_only ? `/shorts/${c.id}` : `/channel/${c.id}`,
          description: c.description,
        }))}
      />
      <div className="flex items-start justify-between flex-wrap gap-4 mb-8">
        <h1 className="font-display text-5xl">Chaînes</h1>
        {hasShortsChannels && (
          <Link
            to="/shorts"
            data-testid="link-shorts-fyp"
            className="group inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gradient-to-r from-orange-500 via-red-500 to-pink-500 text-white text-xs uppercase tracking-widest font-semibold shadow-lg hover:brightness-110 hover:shadow-xl transition"
          >
            <Sparkles className="w-4 h-4 group-hover:rotate-12 transition-transform" />
            Pour toi · FYP
          </Link>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 stagger">
        {channels.map(c => (
          <Link
            to={c.shorts_only ? `/shorts/${c.id}` : `/channel/${c.id}`}
            key={c.id}
            data-testid={`channel-tile-${c.id}`}
            className="card-hover rounded-xl overflow-hidden border border-[color:var(--border)] bg-[color:var(--bg-elev)] relative"
          >
            <div className="h-28 relative" style={{ background: `linear-gradient(135deg, ${c.color}, transparent)` }}>
              {c.logo && (
                <img
                  src={c.logo}
                  alt={c.name}
                  className="absolute bottom-2 right-3 w-16 h-16 object-contain rounded-md bg-black/30 backdrop-blur-md p-1.5"
                  loading="lazy"
                />
              )}
              {c.live_active && c.live_hls_url && (
                <div
                  data-testid={`live-badge-${c.id}`}
                  className="absolute top-3 left-3 inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-red-500 text-white text-[10px] uppercase tracking-widest font-bold shadow-lg"
                >
                  <span className="relative inline-flex w-1.5 h-1.5">
                    <span className="absolute inset-0 rounded-full bg-white animate-ping" />
                    <span className="relative rounded-full bg-white w-1.5 h-1.5" />
                  </span>
                  En direct
                </div>
              )}
              {c.shorts_only && (
                <div
                  data-testid={`shorts-badge-${c.id}`}
                  className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-md text-[10px] uppercase tracking-widest font-semibold text-white border border-white/10"
                >
                  <Film className="w-3 h-3 text-[color:var(--accent)]" /> Shorts
                </div>
              )}
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2 h-2 rounded-full" style={{ background: c.color }} />
                <span className="text-xs uppercase tracking-widest text-[color:var(--text-muted)]">{c.category}</span>
              </div>
              <div className="font-display text-3xl">{c.name}</div>
              <p className="text-sm text-[color:var(--text-muted)] mt-2 line-clamp-2">{c.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
